import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CallingMissedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallingMissed",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.24 16.52c.14.39.31.77.5 1.17 1.21 2.48 2.75 4.59 4.59 6.4a22.9 22.9 0 0 0 6.27 4.54l.13.06c.71.35 1.55.67 2.43.92l.11.03c2.64.71 5 .43 6.44-1.01l1.35-1.35c.35-.35.56-.83.56-1.35s-.21-1.01-.56-1.35l-3.62-3.62c-.35-.35-.83-.56-1.35-.56s-1.01.21-1.35.56L16.1 23.6c-.23.23-.55.37-.91.37s-.67-.14-.91-.37l-5.45-5.41c-.23-.23-.38-.55-.38-.91s.14-.67.38-.91l2.64-2.64c.35-.35.56-.83.56-1.35s-.21-1.01-.56-1.35l-3.6-3.64c-.35-.35-.83-.56-1.35-.56s-1.01.21-1.35.56L3.81 8.74c-1.69 1.7-1.78 4.62-.57 7.82Zm14.02-2.21c.19.19.45.31.74.31s.55-.12.74-.31l4.51-4.51 4.51 4.51c.19.19.45.31.74.31.58 0 1.05-.47 1.05-1.05 0-.29-.12-.55-.31-.74l-4.51-4.51 4.51-4.51c.19-.19.31-.45.31-.74s-.12-.55-.31-.74-.45-.31-.74-.31-.55.12-.74.31l-4.51 4.51-4.51-4.51c-.19-.19-.45-.31-.74-.31s-.55.12-.74.31-.31.45-.31.74.12.55.31.74l4.51 4.51-4.51 4.51c-.19.19-.31.45-.31.74s.12.55.31.74"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M20.86 28c-1.83 0-3.65-.7-5.05-2.09l-9.73-9.73a7.1 7.1 0 0 1-1.27-8.36c.26-.49.86-.68 1.35-.42s.68.86.42 1.35c-1.05 2-.68 4.42.92 6.02l9.73 9.73c2 2 5.26 2 7.26 0l1.09-1.09-3.73-3.73a3.046 3.046 0 0 1-4.2-.1l-5.26-5.26c-.58-.57-.89-1.34-.89-2.15 0-.76.28-1.48.79-2.04L7.88 5.72a.996.996 0 1 1 1.41-1.41l5.11 5.11c.19.19.29.44.29.71s-.11.52-.29.71l-.6.6a1.037 1.037 0 0 0 0 1.48l5.26 5.26c.4.4 1.03.41 1.44.03l.69-.63c.39-.36 1-.35 1.38.03l5.11 5.11c.39.39.39 1.02 0 1.41l-1.8 1.8a7.13 7.13 0 0 1-5.05 2.09ZM21 12c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l6-6a.996.996 0 1 1 1.41 1.41l-6 6c-.2.2-.45.29-.71.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27 12c-.26 0-.51-.1-.71-.29l-6-6A.996.996 0 1 1 21.7 4.3l6 6a.996.996 0 0 1-.71 1.7Z"
      })]
    })
  }));
};